<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="check" :title="$t('store.check_title')"/>
    <div class="rule container help_check">
      <h1 class="title lkrule"><span>{{ $t("store.check_title") }}</span></h1>

      <section class="rule-cont" v-for="item in $t('store.check_list')">
        <div class="help_check-group">
          <div class="left">
            <div :class="item.imgPath"></div>
            <!--<img :src="require(`@/website/${DEF_webStyle}/images/${item.imgPath}.webp`)" />-->
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <p>{{ item.cont1 }}</p>
            <p>{{ item.cont2 }}</p>
            <p>{{ item.cont3 }}</p>
            <p>{{ item.cont4 }}</p>
            <p>{{ item.cont5 }}</p>
            <p>{{ item.cont6 }}</p>
            <p>{{ item.cont7 }}</p>
            <p>{{ item.cont8 }}</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    layout: "desktop",
    components: { pageHead }
  };
</script>
